import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_DEFAULTS } from '../constants';
import { CONTACT } from '../data/contact';

const SEO = ({
  title = SEO_DEFAULTS.title,
  description = SEO_DEFAULTS.description,
  keywords = SEO_DEFAULTS.keywords,
  image = `${CONTACT.siteUrl}/assets/images/og-image.jpg`,
  url = CONTACT.siteUrl,
  type = 'website',
}) => {
  const absoluteImage = image.startsWith('http')
    ? image
    : `${CONTACT.siteUrl}${image.startsWith('/') ? '' : '/'}${image}`;

  return (
  <Helmet>
    <title>{title}</title>
    <meta name="title" content={title} />
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <meta name="robots" content="index, follow" />
    <meta name="author" content={SEO_DEFAULTS.author} />

    <meta property="og:type" content={type} />
    <meta property="og:url" content={url} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={absoluteImage} />
    <meta property="og:site_name" content={CONTACT.siteName} />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:url" content={url} />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={absoluteImage} />

    <link rel="canonical" href={url} />

    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: CONTACT.siteName,
        url: CONTACT.siteUrl,
        description: SEO_DEFAULTS.description,
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: CONTACT.phone,
          contactType: 'sales',
          email: CONTACT.email,
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: CONTACT.office.city,
          addressRegion: CONTACT.office.region,
          addressCountry: CONTACT.office.country,
        },
      })}
    </script>
  </Helmet>
  );
};

export default SEO;
